<template>
    <div class="opfl-filter-row" :class="rowClass">
        <div class="opfl-filter-row-container">
            <div>
                <RichSelect
                    :settings="{ ajax: { url: this.fieldsUrl, dataType: 'json' } }"
                    :ajaxUrl="this.fieldsUrl"
                    v-model="row.field_id"
                    :modelValue="row.field_id"
                    :placeholder="'Select field'"
                    @select="fieldSelected"
                >
                    <option :value="row.field_id" selected :key="row.field_id" v-if="row.field_id">
                        {{ row.field_title ? row.field_title : row.field_id }}
                    </option>
                </RichSelect>
            </div>

            <div v-if="row.field_id">
                <RichSelect
                    v-model="row.operator"
                    :modelValue="row.operator"
                    @select="operatorSelected"
                    @options="operatorOptionsChanged"
                    :options="operatorOptions"
                />
            </div>

            <div v-if="row.field_id && row.operator !== 'empty' && row.operator !== 'not_empty'" class="opfl-filter-value-container">
                <DateValue    :row="row" @change="setRowValue"      v-if="row.field_id === 'filter/date/datetime'" />
                <DayValue     :row="row" @change="setRowValue" v-else-if="row.field_id === 'filter/date/day'" />
                <MonthValue   :row="row" @change="setRowValue" v-else-if="row.field_id === 'filter/date/month'" />
                <NumericValue :row="row" @change="setRowValue" v-else-if="row.field_id === 'filter/date/year'" />
                <TextValue    :row="row" @change="setRowValue"    v-else />
            </div>
        </div>

        <a href="#" class="opfl-remove-filter-row" @click.prevent="$emit('remove', row)" v-if="index > 0"><i class="opui-icon-close"></i></a>

        <div class="opfl-filter-row-connector"><div class="opui-text">{{ $e('AND') }}</div></div>
    </div>
</template>

<script>
import RichSelect from "../../Global/RichSelect.vue"
import DateValue from "./DateValue.vue"
import DayValue from "./DayValue.vue"
import MonthValue from "./MonthValue.vue"
import NumericValue from "./NumericValue.vue"
import TextValue from "./TextValue.vue"

export default {
    components: { DateValue, DayValue, MonthValue, NumericValue, RichSelect, TextValue },
    props: {
        workflow: { type: Object,  required: true },
        item:     { type: Object,  required: true },
        row:      { type: Object,  required: true },
        index:    { type: Number,  required: true },
    },
    data() {
        return {
            selectSettings: { minimumResultsForSearch: -1 }
        }
    },
    mounted() {
        // console.log(window.OptimizeFlow.config);
    },
    computed: {
        fieldsUrl() {
            let path = 'flow/filter-fields?workflow_uid=' + this.workflow.uid

            return this.restUrl(path)
        },

        operatorsUrl() {
            let path = 'flow/filter-operators?workflow_uid=' + this.workflow.uid + '&field=' + this.row.field_id

            return this.restUrl(path)
        },

        operatorOptions() {
            let config = this.findFilterConfig(this.row.field_id)

            if (config && config.operators) {
                return config.operators
            } else {
                return [
                    { id: 'equals',    text: 'equals' },
                    { id: 'empty',     text: 'is empty' },
                    { id: 'not_empty', text: 'is not empty' },
                ]
            }
        },

        rowClass() {
            if (this.row.field_id) {
                return 'opfl-filter-row-cols-2'
            }
        }
    },
    methods: {
        fieldSelected(selected) {
            this.row.value          = null
            // this.row.operator       = 'equals'
            // this.row.operator_title = 'equals'
            this.row.field_title    = selected.text
        },

        operatorSelected(selected) {
            this.row.operator_title = selected.text

            if (this.row.operator === 'empty' || this.row.operator === 'not_empty') {
                this.row.value = ''
            }
        },
        
        operatorOptionsChanged(sel) {
            if (sel[0] && sel[0].id && sel[0].text) {
                this.row.operator       = sel[0].id
                this.row.operator_title = sel[0].text
            }
        },

        setRowValue(value) {
            // TODO: decide if we even need this
        },

        remove() {
            this.emit('remove', this.item)
        }
    }
}
</script>

<style scoped>
.opfl-filter-row {
    display: block;
    position: relative;
    //grid-template-columns: 1fr;
    //gap: 16px;
    margin-bottom: 16px;
    padding-bottom: 0;
}

.opfl-filter-row-container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
}

.opfl-filter-row-cols-2 .opfl-filter-row-container {
    grid-template-columns: 1fr 1fr;
}

.opfl-filter-row-cols-3 .opfl-filter-row-container {
    grid-template-columns: 1fr 1fr 1fr;
}

.opfl-filter-value-container {
    //margin-top: -10px;
    //display: grid;
    grid-column: span 2;
    //padding-bottom: 32px;
}

.opfl-remove-filter-row {
    position: absolute;
    top: 16px;
    right: -20px;
    font-size: 12px;
    color: #ccc;
    text-decoration: none;
}

.opfl-filter-row-connector {
    position: relative;
    width: 100%;
    text-align: center;
    margin-top: 16px;
    padding: 10px 0;
}

.opfl-filter-row:last-child .opfl-filter-row-connector {
    display: none;
}

.opfl-filter-row-connector .opui-text {
    //position: absolute;
    //top: 0;
    //left: 50%;
    //margin-left: -17px;
    display: inline-block;
    border: 1px solid #ddd;
    border-radius: 3px;
    color: #aaa;
    padding: 2px 5px;
    font-size: 11px;
}
</style>
